import * as actionTypes from '../types/pieceInfo';

export function getPieceDetails(payload) {
  return {
    type: actionTypes.GET_PIECE_DETAILS,
    payload
  };
}
export function getPieceDetailsSuccess(payload) {
  return {
    type: actionTypes.GET_PIECE_DETAILS_SUCCESS,
    payload
  };
}
export function getPieceDetailsFail(payload) {
  return {
    type: actionTypes.GET_PIECE_DETAILS_FAIL,
    payload
  };
}
